import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Routes, Route, useNavigate, Navigate } from "react-router-dom";
import { Login } from "../component/page/login";
import { rutas } from "../rutas/rutas";
import { login, setInformacion, setGeneralNft,setEspeciales } from "../storage/slices/usuarios";
import { DashboardRouterGame } from "./DashboardRoute";
import { PrivateRouter } from "./PrivateRouter";
import axios from 'axios'
import { getCookie } from "../utils/getCookie";
export const AppRouter = () => {
    const {usuario}  = useSelector(state=> state.userSlice)
    const result = JSON.parse(sessionStorage.getItem('user'))
    const dispatch = useDispatch()
    //const { deck } = useSelector((state) => state.deckSlice);
    const navigate = useNavigate()

    useEffect(()=>{
        if(result?.logged && result?.user){
        

          dispatch(login(result))

          const tokenJWT = getCookie('token')
        axios.get(`${rutas.getCards}`, { headers: {'token': tokenJWT}}).then(res=> {
       
          const especial  = res.data.especiales
            const deckSave = res.data.generalNft
            dispatch(setEspeciales(especial))
            dispatch(setGeneralNft(deckSave))
          })
        axios.get(`${rutas.getInformacion}`, { headers: {'token': tokenJWT}})
        .then(res=> {
            dispatch(setInformacion({...res.data?.resultado}));
            navigate('/game', {
              replace:true
            })
        })
        .catch(err=> {
          console.log('error')
            sessionStorage.setItem('user',JSON.stringify({logged: false}))
            navigate('/login','/game', {
                replace:true
              })
        })
        
      }
    },[])
    useEffect(() => {
      if(!usuario) return
      sessionStorage.setItem('user', JSON.stringify(usuario))
    
    }, [usuario])
    
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" />} />
      <Route path="/login/:ref" element={<Login />} />
      <Route path="/login" element={<Login />} />
    
      <Route
        path="/game/*"
        element={
          <PrivateRouter>
            <DashboardRouterGame />
          </PrivateRouter>
        }
      />
    </Routes>
  );
};
